var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricCellValue, widgetMetricTableColMetricPeriodDiffLeanStyle, widgetMetricTableColMetricPeriodDiffWorkPatternsStyle, widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell, metricTableTeamAvgDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { classNames, getIconByItemType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToCreatedItemByType } from '@web/utility/chartNavigation';
import { ComparisonPeriod } from '@web/utility/comparisonPeriod';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getPreviousPeriod } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var createdItemsByTypeCreatedPairNoTeam = [
    widgetMetricTableColMetricValueStyle,
    widgetMetricTableColMetricPeriodDiffWorkPatternsStyle
];
var createdItemsByTypeRawValueColStyle = {
    width: '13%',
    minWidth: '7rem'
};
var createdItemsByTypeMetricTrioWithTeam = [
    widgetMetricTableColMetricValueStyle,
    widgetMetricTableColMetricPeriodDiffLeanStyle,
    { width: '1%', minWidth: '5.25rem' }
];
function createdItemsByTypeTableColgroup(includeTeamDiffColumn) {
    if (includeTeamDiffColumn) {
        return __spreadArray(__spreadArray([
            { width: '24%', minWidth: '10.5rem' }
        ], createdItemsByTypeMetricTrioWithTeam, true), [
            createdItemsByTypeRawValueColStyle,
            createdItemsByTypeRawValueColStyle
        ], false);
    }
    return __spreadArray(__spreadArray([
        { width: '28%', minWidth: '10.5rem' }
    ], createdItemsByTypeCreatedPairNoTeam, true), [
        createdItemsByTypeRawValueColStyle
    ], false);
}
var createdItemsByTypeHeaderThClass = 'min-w-[10.5rem] sm:min-w-0 !text-left !pl-3 whitespace-nowrap';
export var CreatedItemsByType = function (_a) {
    var createdItemsData = _a.createdItemsData, isLoading = _a.isLoading, refetch = _a.refetch, userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var _c = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _c.prevPeriodDateFrom, prevPeriodDateTo = _c.prevPeriodDateTo;
    var navigateToItem = function (itemType, period) {
        var scope = period === ComparisonPeriod.Previous
            ? __assign(__assign({}, navigationScope), { dateFrom: prevPeriodDateFrom, dateTo: prevPeriodDateTo }) : period === ComparisonPeriod.Team
            ? __assign(__assign({}, navigationScope), { userId: null }) : navigationScope;
        navigateToCreatedItemByType(scope, itemType);
    };
    var showTeamDiff = !!userId;
    var createdHeaderColspan = showTeamDiff ? 3 : 2;
    var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
    var columns = __spreadArray([
        {
            title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.label'),
            isVisible: true,
            className: createdItemsByTypeHeaderThClass
        },
        {
            title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.created'),
            isVisible: true,
            colspan: createdHeaderColspan,
            className: headerMetricClass
        },
        {
            title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.previousPeriod'),
            isVisible: true,
            className: createdItemsByTypeHeaderThClass
        }
    ], (showTeamDiff
        ? [
            {
                title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.teamAverage'),
                isVisible: true,
                className: createdItemsByTypeHeaderThClass
            }
        ]
        : []), true);
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var items = (createdItemsData === null || createdItemsData === void 0 ? void 0 : createdItemsData.byType) || [];
    var tableData = items.map(function (item) {
        var _a;
        var rk = item.label;
        var createdCells = [
            {
                id: "created-value-".concat(rk),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: function () {
                        return navigateToItem(item.label, ComparisonPeriod.Current);
                    } }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: item.created })) }))); }
            },
            metricTablePeriodDiffRowCell("created-period-".concat(rk), item.previousPeriod.diff, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            createdCells.push(metricTableTeamAvgDiffRowCell("created-team-".concat(rk), (_a = item.teamAverage) === null || _a === void 0 ? void 0 : _a.diff, isSecondaryDiffHidden));
        }
        var row = __spreadArray(__spreadArray([
            {
                id: "item-".concat(rk),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'min-w-[10.5rem] sm:min-w-0'),
                render: function () { return (_jsxs("div", __assign({ className: "flex min-w-0 max-w-full items-center gap-2" }, { children: [_jsx("div", __assign({ className: "flex h-6 w-6 shrink-0 items-center justify-center" }, { children: getIconByItemType(item.label) })), _jsx("div", __assign({ className: "min-w-0 text-base font-semibold break-words" }, { children: item.label }))] }))); }
            }
        ], createdCells, true), [
            {
                id: "previousPeriod-".concat(rk),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: function () {
                        return navigateToItem(item.label, ComparisonPeriod.Previous);
                    } }, { children: _jsx("span", __assign({ className: widgetMetricCellValue }, { children: item.previousPeriod.value })) }))); }
            }
        ], false);
        if (showTeamDiff) {
            row.push({
                id: "teamAverage-".concat(rk),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () {
                    var _a, _b;
                    return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: function () {
                            return navigateToItem(item.label, ComparisonPeriod.Team);
                        } }, { children: _jsx("span", __assign({ className: widgetMetricCellValue }, { children: (_b = (_a = item.teamAverage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0 })) })));
                }
            });
        }
        return row;
    });
    return (_jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.createdItemsByType'), description: t('widgetTitleDescriptions.initiativeAndOwnership.createdItemsByType'), insightType: InsightTypeEnum.createdItemsByType, insightsData: items, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.createdItemsByType'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (items !== null && items !== void 0 ? items : []).map(function (item) {
                                    var _a, _b;
                                    var _c;
                                    return (__assign((_a = {}, _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.label')] = item.label, _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.created')] = item.created, _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.previousPeriod')] = item.previousPeriod.value, _a), (userId && (_b = {},
                                        _b[t('export.teamAverage')] = (_c = item.teamAverage) === null || _c === void 0 ? void 0 : _c.value,
                                        _b))));
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(items !== null && items !== void 0 ? items : []) }) }), _jsx(Table, { data: isInsightsDataEmpty(items !== null && items !== void 0 ? items : []) ? [] : tableData, columns: columns, columnColStyles: createdItemsByTypeTableColgroup(showTeamDiff), tableClassName: classNames('w-full table-auto', showTeamDiff ? 'min-w-[52rem]' : 'min-w-[40rem]'), rowClassName: "[&>td]:align-top" })] })));
};
